import { LegacyButton as Button } from 'components/Button/LegacyButton';
import { Icon } from 'components/Icon';

import { ArrowNavigationContainer } from './ArrowNavigation.styled';

type Props = {
  nextPage: () => void;
  prevPage: () => void;
  current: number;
  total: number;
  outset?: boolean;
  showDropShadow?: boolean;
  buttonColor?: string;
  width?: string | number;
  m?: string;
  mt?: number;
};

export function ArrowNavigation({
  nextPage,
  prevPage,
  current,
  total,
  outset,
  showDropShadow,
  buttonColor,
  width,
  m,
  mt,
}: Props) {
  const title = {
    prev: getText('Previous page'),
    next: getText('Next page'),
  };

  const prevDisabled = current <= 0;
  const nextDisabled = current >= total - 1;
  return (
    <ArrowNavigationContainer
      classes={['flex', 'align-center', 'justify-between']}
      $outset={outset}
      $showDropShadow={showDropShadow}
      $buttonColor={buttonColor}
      width={width}
      m={m}
      mt={mt}
    >
      <Button
        onClick={prevPage}
        aria-label={title.prev}
        title={title.prev}
        disabled={prevDisabled}
        data-qa-id="carousel-left-button"
      >
        <Icon name="chevron-left" size={24} />
      </Button>
      <Button
        onClick={nextPage}
        aria-label={title.next}
        title={title.next}
        disabled={nextDisabled}
        data-qa-id="carousel-right-button"
      >
        <Icon name="chevron-right" size={24} />
      </Button>
    </ArrowNavigationContainer>
  );
}
